<script context="module">
    import {isLoggedIn, session} from 'src/services/auth'
</script>
<script lang="ts">
    import {Route} from 'svelte-routing'
    import Login from './login/Login.svelte'
    import Vesting from './vesting/Vesting.svelte'
    import History from './history/History.svelte'
    import TwoFactor from 'src/components/cabinet/two-factor/TwoFactor.svelte'
    import Error404 from "./404/404.svelte"
    import RouteAuthOnly from '../#common/authOnly/RouteAuthOnly.svelte'
</script>

<Route path="/">
    {#if !$isLoggedIn}
        <Login/>
    {:else if $session?.isNeed2fa}
        <TwoFactor/>
    {:else}
        <Vesting/>
    {/if}
</Route>
<RouteAuthOnly path="history"><History/></RouteAuthOnly>
<Route><Error404/></Route>
